import React, { useState } from "react";
import { Navbar, Nav, Button, Dropdown, Offcanvas } from "react-bootstrap";
import { FaUserCircle } from "react-icons/fa";
import "./styles/DashboardHeader.css";
import OBHeaderLogo from "../assets/ob_header_logo.png";

import dashboardIcon from "../assets/dash-h-dash-icon.svg";
import bookingIcon from "../assets/dash-h-booking-icon.svg";
import specialOfferIcon from "../assets/h-special-offers-icon.svg";
import availiblityIcon from "../assets/dash-h-avaliability-icon.svg";
import performanceIcon from "../assets/dash-h-perfomance-icon.svg";
import financeIcon from "../assets/dash-h-finance-icon.svg";
import productIcon from "../assets/dash-h-product-icon.svg";
import { Icon } from "@iconify/react/dist/iconify.js";
import CreateProductBtn from "./CreateProductBtn";
import { Link, useNavigate } from "react-router-dom";
import { useGetUserProfileQuery } from "../rtk-query/slices/profile/profileSlice";
import { baseAPI } from "../rtk-query/baseApi";
import { toast } from "react-toastify";

const DashboardHeader = () => {
  const { data: userProfile } = useGetUserProfileQuery();

  const navigate = useNavigate();
  const [showOffcanvas, setShowOffcanvas] = useState(false);

  const handleOffcanvasToggle = () => setShowOffcanvas(!showOffcanvas);

  let canClickable =
    userProfile?.data?.supplier?.status === "Approved" ? true : false;

  const handleLinkClick = () => {
    if (!canClickable) {
      toast.warn("Your profile is under review. Please wait for approval.");
    }
  };

  return (
    <>
      {/* Main Navbar */}
      <Navbar expand="lg" className="dod-dash-header-navbar">
        <Navbar.Brand to="#home" className="dod-dash-header-brand">
          <img src={OBHeaderLogo} alt="logo" width={146} height={34} />
        </Navbar.Brand>
        <Nav className="mr-auto gap-3 dod-dash-header-nav">
          {/* Navigation Links for Desktop */}
          <Link
            to="/"
            className={`d-flex align-items-center gap-1 flex-nowrap dod-dash-header-nav-link ${
              window.location.pathname === "/" ? "active" : ""
            }`}
          >
            <img src={dashboardIcon} alt="dashboard" />
            Dashboard
          </Link>
          <Link
            to={canClickable ? "/products" : "#"}
            onClick={handleLinkClick}
            className={`d-flex align-items-center gap-1 flex-nowrap dod-dash-header-nav-link ${
              window.location.pathname === "/products" ? "active" : ""
            }`}
          >
            <img src={productIcon} alt="products" />
            Products
          </Link>
          {/* <Link
            to={canClickable ? "/special-offers" : "#"}
            onClick={handleLinkClick}
            className={`d-flex align-items-center gap-1 flex-nowrap dod-dash-header-nav-link ${
              window.location.pathname === "/special-offers" ? "active" : ""
            }`}
          >
            <img src={specialOfferIcon} alt="booking" />
            Special Offers
          </Link> */}
          <Link
            to={canClickable ? "/bookings" : "#"}
            onClick={handleLinkClick}
            className={`d-flex align-items-center gap-1 flex-nowrap dod-dash-header-nav-link ${
              window.location.pathname === "/bookings" ? "active" : ""
            }`}
          >
            <img src={bookingIcon} alt="booking" />
            Bookings
          </Link>
          {/* <Link
            to={canClickable ? "#" : "#"}
            onClick={handleLinkClick}
            className={`d-flex align-items-center gap-1 flex-nowrap dod-dash-header-nav-link ${
              window.location.pathname === "/availability" ? "active" : ""
            }`}
          >
            <img src={availiblityIcon} alt="availability" />
            Availability
          </Link>
          <Link
            to={canClickable ? "#" : "#"}
            onClick={handleLinkClick}
            className={`d-flex align-items-center gap-1 flex-nowrap dod-dash-header-nav-link ${
              window.location.pathname === "/performance" ? "active" : ""
            }`}
          >
            <img src={performanceIcon} alt="performance" />
            Performance
          </Link> */}
          <Link
            to={canClickable ? "/finance" : "#"}
            onClick={handleLinkClick}
            className={`d-flex align-items-center gap-1 flex-nowrap dod-dash-header-nav-link ${
              window.location.pathname === "/finance" ? "active" : ""
            }`}
          >
            <img src={financeIcon} alt="finance" />
            Finance
          </Link>
        </Nav>

        <div className="d-flex">
          {/* Create Product Button */}
          {/* <CreateProductBtn /> */}

          {/* Profile and Menu Icons */}
          <div className="d-flex align-items-center dod-dash-header-icons">
            {/* Profile Dropdown */}
            <Dropdown align="end">
              <Dropdown.Toggle
                variant="link"
                id="dropdown-profile"
                className="p-0 dod-dash-header-profile-dropdown"
              >
                {userProfile?.data?.supplier?.supplier_company_logo ? (
                  <img
                    src={userProfile?.data?.supplier?.supplier_company_logo}
                    alt="user-profile"
                  />
                ) : (
                  <FaUserCircle size={35} />
                )}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item as={Link} to="/view-profile">
                  View Profile
                </Dropdown.Item>
                <Dropdown.Item as={Link} to="/edit-profile">
                  Edit Profile
                </Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Item
                  as={Button}
                  onClick={(e) => {
                    e.preventDefault();
                    baseAPI.util.resetApiState();
                    localStorage.removeItem("DODLoginToken");
                    localStorage.removeItem("productId");
                    localStorage.removeItem("DODAdminCreatedBy");
                    navigate("/login");
                  }}
                >
                  Logout
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
            {/* Mobile Menu Icon */}
            <Button
              variant="link"
              className="p-0 dod-dash-header-menu-btn"
              onClick={handleOffcanvasToggle}
            >
              <Icon icon="iconoir:menu" size={30} />
            </Button>
          </div>
        </div>
      </Navbar>

      {/* Offcanvas Menu for Mobile */}
      <Offcanvas
        show={showOffcanvas}
        onHide={handleOffcanvasToggle}
        placement="end"
        className="dod-dash-header-offcanvas"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title className="ob-page-main-heading">
            Menu
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {/* Navigation Links for Offcanvas */}
          <Nav className="flex-column gap-3 dod-dash-header-offcanvas-nav">
            <Link
              to="#"
              className="d-flex align-items-center gap-1 flex-nowrap dod-dash-header-nav-link"
            >
              <img src={dashboardIcon} alt="dashboard" />
              Dashboard
            </Link>
            <Link
              to={canClickable ? "/products" : "#"}
              onClick={handleLinkClick}
              className="d-flex align-items-center gap-1 flex-nowrap dod-dash-header-nav-link"
            >
              <img src={productIcon} alt="booking" />
              Products
            </Link>
            <Link
              to={canClickable ? "/bookings" : "#"}
              onClick={handleLinkClick}
              className="d-flex align-items-center gap-1 flex-nowrap dod-dash-header-nav-link"
            >
              <img src={bookingIcon} alt="booking" />
              Bookings
            </Link>
            {/* <Link
              to={canClickable ? "/special-offers" : "#"}
              onClick={handleLinkClick}
              className="d-flex align-items-center gap-1 flex-nowrap dod-dash-header-nav-link"
            >
              <img src={specialOfferIcon} alt="booking" />
              Special Offers
            </Link> */}
            {/* <Link
              to={canClickable ? "#" : "#"}
              onClick={handleLinkClick}
              className="d-flex align-items-center gap-1 flex-nowrap dod-dash-header-nav-link"
            >
              <img src={availiblityIcon} alt="availability" />
              Availability
            </Link>
            <Link
              to={canClickable ? "#" : "#"}
              onClick={handleLinkClick}
              className="d-flex align-items-center gap-1 flex-nowrap dod-dash-header-nav-link"
            >
              <img src={performanceIcon} alt="performance" />
              Performance
            </Link> */}
            <Link
              to={canClickable ? "/finance" : "#"}
              onClick={handleLinkClick}
              className="d-flex align-items-center gap-1 flex-nowrap dod-dash-header-nav-link"
            >
              <img src={financeIcon} alt="finance" />
              Finance
            </Link>
            {/* Create Product Button */}
            {/* <div className="mt-5 w-100 d-flex">
              <Button
                onClick={(e) => {
                  e.preventDefault();
                  if (canClickable) {
                    navigate("/create-product");
                  } else {
                    handleLinkClick();
                  }
                }}
                variant="outline-primary"
                style={{
                  marginRight: "0px",
                }}
                className="m-0 dod-dash-header-create-btn w-100"
              >
                + Create a product
              </Button>
            </div> */}
          </Nav>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default DashboardHeader;
